export function createCurrentUser(user) {
    return Object.assign(Object.assign({}, user), { settings: user.settings || {} });
}
